import api from '@/api';

const { $pricing, $academic, $student , $identity } = api;

export const { $types } = $pricing;
export const { $products } = $pricing;
export const { $terms } = $academic;
export const { $tools } = $student;
export const { $cognito } = $identity;
